import { HomeOutlined } from '@mui/icons-material';
import { IRoute } from '../interfaces';
import { lazyWithRetry } from '../utils/lazyWithRetry';

// Lazy load all components with retry logic
const SignUp = lazyWithRetry(() => import('../pages/Signup'));
const LandingSignup = lazyWithRetry(() => import('../pages/LandingSignup/LandingSignup'));
const Login = lazyWithRetry(() => import('../pages/Login'));
const Password = lazyWithRetry(() => import('../pages/Password'));
const PropertyLanding = lazyWithRetry(
  () => import('../pages/PropertyLanding/PropertyLanding')
);
const CoSignerPortal = lazyWithRetry(
  () => import('../pages/CoSignerPortal/CoSignerPortal')
);
const EstimateReport = lazyWithRetry(() => import('../pages/Estimate/EstimateReport'));
const WireInstructions = lazyWithRetry(() => import('../pages/WireInstructions/WireInstructions'));
const TestimonialRecorder = lazyWithRetry(
  () => import('../pages/TestimonialRecorder/TestimonialRecorder')
);
export const routes: Array<IRoute> = [
  { key: 'landing-signup', title: 'Create your account', path: '/signup/landing', enabled: true, component: LandingSignup, icon: HomeOutlined, menu: false, protected: false },
  {
    key: 'login-route',
    title: 'Log In',
    path: '/login',
    enabled: true,
    component: Login,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'signup-route',
    title: 'Sign Up',
    path: '/signup',
    enabled: true,
    component: SignUp,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'password-route',
    title: 'Password',
    path: '/password',
    enabled: true,
    component: Password,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'property-landing-route',
    title: 'Property Landing',
    path: '/p/:trackingId',
    enabled: true,
    component: PropertyLanding,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'co-signer-portal-route',
    title: 'Co-Signer Portal',
    path: '/sign/:token',
    enabled: true,
    component: CoSignerPortal,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'estimate-report-route',
    title: 'Home value report',
    path: '/estimate/:code',
    enabled: true,
    component: EstimateReport,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'wire-instructions-route',
    title: 'Wire instructions',
    path: '/wire/:token',
    enabled: true,
    component: WireInstructions,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'testimonial-recorder-route',
    title: 'Record a Testimonial',
    path: '/testimonial/:token',
    enabled: true,
    component: TestimonialRecorder,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
];
